import { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cadastro from "../../components/Cadastro";
import Login from "../../components/Login";
import Recovery from "../../components/Recovery";
import { UserContext } from "../../context/UserContext";
import { useModal } from "../../context/ModalContext";
import { consumeRedirectAfterLogin } from "../../utils/redirectAfterLogin";

import "../styles/ModalLogin.css";

import arrowRight from "../../assets/images/svg/arrowRight.svg";
import fullLogo from "../../assets/images/svg/unicornio-brown.svg";
import Button from "../Button";

const ModalLogin = () => {
  const [view, setView] = useState("login"); // 'login' | 'cadastro' | 'recuperacao'
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(UserContext);
  const { modalData, openModal } = useModal();

  const hasRedirected = useRef(false);

  // Ao logar: retoma o fluxo que pediu o login (ex.: modalPesquisa do Básico)
  // ou, na ausência disso, navega para o destino padrão.
  useEffect(() => {
    if (isAuthenticated && !hasRedirected.current) {
      hasRedirected.current = true;

      if (modalData?.resumeType) {
        openModal(modalData.resumeType, modalData.resumeData);
        return;
      }

      const dismissThenGo = (to) => {
        const el = document.getElementById("bootstrapModal");
        const bs = window?.bootstrap;
        if (el && bs?.Modal) {
          const inst =
            bs.Modal.getInstance(el) || bs.Modal.getOrCreateInstance(el);
          // Navegar imediatamente sem aguardar a animação, para evitar bounce
          navigate(to);
          inst.hide();
        } else {
          navigate(to);
        }
      };
      // Destino padrão após login
      const redirect = consumeRedirectAfterLogin("/minha-conta");
      dismissThenGo(redirect);
    }
  }, [isAuthenticated, navigate, modalData, openModal]);

  return (
    <div className="ModalLogin" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-lg-4">
            <img src={fullLogo} alt="Puríssima" className="logoModalLogin" />
          </div>
        </div>
        <div className="row justify-content-center align-items-center">
          <div className="col-12 text-center">
            {view === "login" && <Login inModal={true} />}
            {view === "cadastro" && <Cadastro />}
            {view === "recuperacao" && <Recovery />}
          </div>
          <div className="col-auto">
            <div className="mt-5 px-3">
              {view !== "login" && (
                <Button
                  classes="mx-auto"
                  onClick={() => setView("login")}
                  label="Voltar para login"
                />
              )}
              {view === "login" && (
                <>
                  <div className="text-center">
                    <a
                      onClick={() => setView("recuperacao")}
                      className="btn btn-link"
                    >
                      Esqueceu sua senha?{" "}
                      <img className="ms-2" src={arrowRight} alt="ordersIcon" />
                    </a>
                    <hr />
                    <Button
                      classes="mx-auto"
                      onClick={() => setView("cadastro")}
                      label="Criar minha conta"
                    />
                    <p className="mt-3">
                      * Importante para que possamos armazenar seus dados da
                      avaliação. Verifique seu SPAM após criar a conta.
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLogin;
